import React, { useEffect, useRef } from 'react';
import { generateBadgeCard } from 'app/utils/BadgeUtils';
import { generateBadgeCardHorizontal } from 'app/utils/BadgeUtilsHorizontal';

const BadgeCard = ({ user, onChangePhoto, onCropPhoto, originalPhotoUrl, layout = 'vertical' }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const renderBadge = async () => {
      if (containerRef.current && user) {
        const generator =
          layout === 'horizontal' ? generateBadgeCardHorizontal : generateBadgeCard;
        const badgeElement = await generator(user);

        if (!cancelled && containerRef.current) {
          containerRef.current.innerHTML = '';
          containerRef.current.appendChild(badgeElement);

          // Botão "Alterar" - escolher nova foto
          const btnChange =
            containerRef.current.querySelector('.badge-btn-change');
          if (btnChange && onChangePhoto) {
            btnChange.addEventListener('click', (e) => {
              e.stopPropagation();
              onChangePhoto();
            });
          }

          // Botão "Ajustar" - abrir crop da foto ORIGINAL
          const btnCrop = containerRef.current.querySelector('.badge-btn-crop');
          if (btnCrop && onCropPhoto && originalPhotoUrl) {
            btnCrop.addEventListener('click', (e) => {
              e.stopPropagation();
              onCropPhoto(originalPhotoUrl); // Passa a URL da foto ORIGINAL
            });

            // Estilização para indicar que está habilitado
            btnCrop.style.opacity = '1';
            btnCrop.style.cursor = 'pointer';
            btnCrop.disabled = false;
          } else if (btnCrop && !originalPhotoUrl) {
            // Se não tem foto ainda, desabilita o botão de ajustar
            btnCrop.style.opacity = '0.5';
            btnCrop.style.cursor = 'not-allowed';
            btnCrop.disabled = true;
          }
        }
      }
    };
    renderBadge();

    return () => {
      cancelled = true;
    };
  }, [user, onChangePhoto, onCropPhoto, originalPhotoUrl, layout]);

  return <div ref={containerRef} />;
};

export default BadgeCard;
